import type { Entry } from "contentful";
import { Link } from "react-router";
import { Autoplay, EffectFade } from "swiper/modules";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";

import { Carousel } from "~/components/ui/carousel";
import type { TypeMediaWithLinkSkeleton } from "~/contentful/compiled";
import { useURL } from "~/contexts";

import { ContentfulImage } from "./contentful-image";

export const HomePageSlot = ({
  content,
}: {
  content:
    | Entry<TypeMediaWithLinkSkeleton, "WITHOUT_UNRESOLVABLE_LINKS", string>
    | undefined;
}) => {
  const url = useURL();
  const inspectorProps = useContentfulInspectorMode();

  if (!content) return null;

  return (
    <Link
      to={url(content?.fields.link || "")}
      key={content?.sys.id}
      className="pointer-events-auto relative order-1 box-border block w-1/2 shrink grow self-auto p-2 sm-max:w-full"
      {...inspectorProps({
        entryId: content?.sys.id,
        fieldId: "name",
      })}
      prefetch="render"
    >
      <label className="w z-1 sr-only absolute bottom-10 mx-auto w-full text-center text-lg font-semibold">
        {content?.fields.title}
      </label>
      <div className="relative -z-10 mx-auto h-full w-full overflow-hidden">
        <Carousel
          loop={true}
          spaceBetween={0}
          effect="fade"
          fadeEffect={{
            crossFade: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          defaultValue={1}
          allowTouchMove={false}
          modules={[Autoplay, EffectFade]}
          className="!h-full"
        >
          {content?.fields.mediaFile.map(file =>
            file?.fields.file?.contentType.includes("image") ? (
              <ContentfulImage
                key={file?.sys.id}
                className="h-full w-full object-cover"
                alt={file?.fields.file?.fileName}
                imageUrl={file?.fields.file?.url}
              />
            ) : (
              <video
                key={file?.sys.id}
                muted
                autoPlay
                src={file?.fields.file?.url}
                loop
                playsInline
                className="h-full w-full object-cover"
              />
            ),
          ) ?? []}
        </Carousel>
      </div>
    </Link>
  );
};
